"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reverseFormatValue = void 0;

var reverseFormatNumber = function reverseFormatNumber(value) {
  if (!value && value !== 0 && value !== '') {
    return;
  }

  var valueAsString = value.toString();
  var trimed = valueAsString.replace(/[,]{2,}/g, ',').replace(/[.]{2,}/g, '.');

  if (trimed.endsWith(',')) {
    return trimed.replace(/\,/g, '.');
  }

  if (trimed.endsWith('.')) {
    return trimed;
  }

  return parseFloat(trimed.replace(/\ /g, '').replace(/\,/g, '.'));
};

var reverseFormatValue = function reverseFormatValue(value) {
  return reverseFormatNumber(value);
};

exports.reverseFormatValue = reverseFormatValue;